import { observer } from "mobx-react-lite";
import {
  ItemListSkeletonRowData,
  ItemListAsyncTemplateRowData,
  ItemListRowType,
} from "@/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { ItemListSkeletonRow } from "./item-list-skeleton-row";
import { ItemListItemRow } from "./item-list-item-row";

export interface ItemListAsyncTemplateRowProps {
  data: ItemListAsyncTemplateRowData;
}

export const ItemListAsyncTemplateRow: FC<ItemListAsyncTemplateRowProps> = observer(({ data }) => {
  const { store } = useAppStore();
  const template = store.templates.get(data.payload.templateId);

  const skeletonRowData: ItemListSkeletonRowData = {
    key: data.key,
    type: ItemListRowType.Skeleton,
    payload: {},
  };
  if (!template) return <ItemListSkeletonRow data={skeletonRowData} />;

  const itemRowData =
    typeof data.payload.itemRow === "function"
      ? data.payload.itemRow(template)
      : data.payload.itemRow;

  return <ItemListItemRow data={itemRowData} />;
});
